module.exports = __webpack_public_path__ + "img/data_security.a87aa256.jpeg";